(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-title"] && !Shopify.designMode) return;
  try {
    (function () {
  // Scrolling-numbers roll (codepen.io/karomancer/pen/dyvEOae): every digit
  // wheel glides from 0 straight to its final digit in ONE simultaneous 2s
  // CSS ease transition — a single smooth compositor-driven motion that
  // decelerates into the final number.
  function animateCount(el, target) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var digits = String(target).split('');
    el.innerHTML = '';
    var strips = [];
    digits.forEach(function (d) {
      var slot = document.createElement('span');
      slot.className = 'sk-digit-slot';
      var strip = document.createElement('span');
      strip.className = 'sk-digit-strip';
      for (var i = 0; i <= 9; i++) {
        var num = document.createElement('span');
        num.textContent = String(i);
        strip.appendChild(num);
      }
      slot.appendChild(strip);
      el.appendChild(slot);
      strips.push({ strip: strip, d: parseInt(d, 10) });
    });
    if (reduce) {
      strips.forEach(function (s) { s.strip.style.transform = 'translateY(-' + s.d + 'em)'; });
      return;
    }
    strips.forEach(function (s) {
      s.strip.style.transition = 'none';
      s.strip.style.transform = 'translateY(0)';
    });
    // Double-RAF so the 0 position paints before the transition starts.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        strips.forEach(function (s) {
          s.strip.style.transition = 'transform 2s ease';
          s.strip.style.transform = 'translateY(-' + s.d + 'em)';
        });
      });
    });
  }

  function initCountDisplay() {
    var display = document.querySelector('.sk-count-display');
    if (!display || display.dataset.initialized) return;
    display.dataset.initialized = '1';

    var count = parseInt(display.dataset.count, 10);
    if (isNaN(count)) return;

    var digitsContainer = display.querySelector('.sk-count-digits');
    display.style.visibility = 'visible';
    animateCount(digitsContainer, count);
  }

  // Huckberry-style read-more: a measured 2-line plain-text preview whose last
  // word fades into an inline "... Read More" at the exact truncation point.
  function initColDesc() {
    var wrap = document.querySelector('[data-sk-col-desc]');
    if (!wrap || wrap.dataset.init) return;
    wrap.dataset.init = '1';
    var textEl = wrap.querySelector('.sk-col-desc__text');
    var btn = wrap.querySelector('.sk-col-desc__more');
    if (!textEl || !btn) return;
    if (textEl.scrollHeight <= textEl.clientHeight + 2) return;  // fits: no toggle

    var words = (textEl.textContent || '').replace(/\s+/g, ' ').trim().split(' ');

    var prev = document.createElement('div');
    prev.className = 'sk-col-desc__preview';
    var holder = document.createElement('span');
    holder.setAttribute('aria-hidden', 'true');
    var lead = document.createElement('span');
    var fade = document.createElement('span');
    fade.className = 'sk-col-desc__fade-word';
    holder.appendChild(lead);
    holder.appendChild(fade);
    holder.appendChild(document.createTextNode('… '));
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'sk-col-desc__more-inline';
    more.textContent = 'Read More';
    more.setAttribute('aria-expanded', 'false');
    prev.appendChild(holder);
    prev.appendChild(more);
    wrap.insertBefore(prev, textEl);
    wrap.classList.add('sk-col-desc--enhanced');

    function setPreview(n) {
      lead.textContent = n > 1 ? words.slice(0, n - 1).join(' ') + ' ' : '';
      fade.textContent = words[n - 1] || '';
    }
    // Largest word count that keeps the preview (incl. "... Read More") at 2 lines
    function fit() {
      var lh = parseFloat(getComputedStyle(prev).lineHeight) || 24;
      var maxH = lh * 2 + 3;
      var lo = 1, hi = words.length, best = 1;
      while (lo <= hi) {
        var mid = (lo + hi) >> 1;
        setPreview(mid);
        if (prev.offsetHeight <= maxH) { best = mid; lo = mid + 1; } else { hi = mid - 1; }
      }
      setPreview(best);
    }
    fit();

    more.addEventListener('click', function () {
      wrap.classList.add('sk-col-desc--open');
      btn.textContent = 'Read Less';
      btn.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    });
    btn.addEventListener('click', function () {
      wrap.classList.remove('sk-col-desc--open');
      btn.hidden = true;
      fit();
    });

    var rT;
    window.addEventListener('resize', function () {
      clearTimeout(rT);
      rT = setTimeout(function () {
        if (!wrap.classList.contains('sk-col-desc--open')) fit();
      }, 150);
    });
  }

  function initAll() {
    // Read-more first: it is ~7 measurements on a two-line box, and the inline
    // "Read More" must be present before the count animation starts so it does
    // not pop in after the counter finishes.
    initColDesc();
    initCountDisplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-title"] && !Shopify.designMode) return;
  try {
    (() => {
    const SKIP = new Set([
      'a','an','the','and','but','or','for','nor','so','yet',
      'at','by','in','of','on','to','up','as','is','it','via',
      'per','vs','from','with','into','than','over','upon'
    ]);

    function fixTitle(el) {
      const text = el.textContent;
      el.textContent = text
        .split(' ')
        .map((word, i) => {
          if (i === 0) return word;
          const lower = word.toLowerCase();
          return SKIP.has(lower) ? lower : word;
        })
        .join(' ');
    }

    function fixAll() {
      document.querySelectorAll('.product-title-block p, .product-title-block h1, .product-title-block h2, .product-title-block h3, .product-title-block h4, .product-title-block h5').forEach(fixTitle);
    }

    document.addEventListener('DOMContentLoaded', fixAll);
    document.addEventListener('page:loaded', fixAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
